export default "__VITE_ASSET__CM75viSl__"